import { enhanceDeviceStatus } from '../components/fleet/fleetPositionHelpers';
import { Config } from '../config';
import { DeviceStatus } from '../interfaces';
import { HttpService } from './http.service';


export abstract class DeviceStatusService {
  public static getDeviceStatuses(): Promise<DeviceStatus[]> {
    const path = `${Config.API}/device_last_status`;

    return HttpService.fetchAuthorized(path).then((res) => {
      if (!res?.data) {
        return [];
      }

      // FIXME this should be done on the BE!
      res.data.sort((a: DeviceStatus, b: DeviceStatus) => {
        const aname = a.vehicle_name || '';
        const bname = b.vehicle_name || '';

        return aname.localeCompare(bname);
      });

      // Add additional fields that are used by other parts of system, like fleet position view
      const enhancedData = res.data.map(enhanceDeviceStatus);

      return enhancedData;
    });
  }

  public static getDeviceLocations(): Promise<DeviceStatus[]> {
    const path = `${Config.API}/device_last_location`;

    return HttpService.fetchAuthorized(path).then((res) => {
      if (!res?.data) {
        return [];
      }

      // FIXME this should be done on the BE!
      res.data.sort((a: DeviceStatus, b: DeviceStatus) => {
        const aname = a.vehicle_name || '';
        const bname = b.vehicle_name || '';

        return aname.localeCompare(bname);
      });

      return res.data;
    });
  }
}
